import { setPageTheme } from '~/helpers/themes'

/**
 * Add full or fragments of paths of pages which handle their own
 * page theme setting. These pages typically set their theme based on
 * fetched CMS data.
 */
const ignorePaths = [
  '/p/'
]

function isDynamicPageThemeRoute (route) {
  if (!route.meta || !route.meta.length) return false
  return route.meta.some(meta => meta.dynamicPageTheme)
}

export default function ({ store, route }) {
  if (!ignorePaths.includes(route.path) || isDynamicPageThemeRoute(route)) {
    return setPageTheme(store)
  }
}
